module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('alert', {
    attrs: {
      "position": "bottom"
    }
  }, [_c('p', [_vm._v("\n\t\t当前路径："), _c('code', [_vm._v(_vm._s(_vm.$route.path))]), _vm._v(";\n\t\t当前参数："), _c('code', [_vm._v(_vm._s(_vm.$route.params))]), _vm._v(";\n\t\t路由名称："), _c('code', [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(";\n\t\t路由查询参数："), _c('code', [_vm._v(_vm._s(_vm.$route.query))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5abaa462!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/routebox.vue
// module id = 315
// module chunks = 2